import { DatePipe } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { AdmincategorySubcategoryAuditlogComponent } from './admincategory-subcategory-auditlog/admincategory-subcategory-auditlog.component';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { EmailTemplatesService } from 'src/app/services/administration/email-templates.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { DateObject } from 'src/app/models/common';

@Component({
  selector: 'app-admin-auditlog-main',
  templateUrl: './admin-auditlog-main.component.html',
  styleUrls: ['./admin-auditlog-main.component.scss']
})
export class AdminAuditlogMainComponent implements OnInit {


maxDate : Date = new Date() ; 
  subSearchRecords: SubscriptionLike;
  subGetData: SubscriptionLike;
  auditTrailSearch = new AuditTrailSearch();
  clonedAuditSearch: AuditTrailSearch = {
    StartDateO: new DateObject,
    EndDateO: new DateObject
  };
  operations;
  tempoperation;
  selectedRow;
  IsAdvanceSearch: boolean = true;
  gridApi: GridApi;
  rowData: any = [];
  columnDefs: any;
  AdminAuditForm: UntypedFormGroup;
  CategoryList: Array<any> = [
    { name: 'Select', SubCategories: [] },
    { name: 'Settings', SubCategories: [] },
    { name: 'Email Setup', SubCategories: [] },
    { name: 'List Values', SubCategories: [] },
    { name: 'User Management', SubCategories: [{ Subname: 'Select' }, { Subname: 'Users' },{ Subname: 'User roles' }, { Subname: 'Department' }] },
    { name: 'ID Configuration', SubCategories: [] },
    { name: 'Program Category', SubCategories: [] },
    { name: 'Product configuration', SubCategories: [{ Subname: 'Select' },{ Subname: 'Product' }, { Subname: 'Product Network locations' }] },
    { name: 'Instructions', SubCategories: [] },
    { name: 'Frequently Asked Questions', SubCategories: [] },
    { name: 'Category and Subcategory', SubCategories: [] },
    { name: 'Document Templates', SubCategories: [] },
    { name: 'Email Templates', SubCategories: [] },
    { name: 'Alerts and Notifications', SubCategories: [{ Subname: 'Select' },{ Subname: 'Alerts and Notifications' }, { Subname: 'Outgoing SMTP' }] },
    // { name: 'Workflow Setup', SubCategories: [] },
    { name: 'Screen repository', SubCategories: [] },
    { name: 'Registrations', SubCategories: [] },
   // { name: 'Dashboards', SubCategories: [] },    
    //{ name: 'EAP Type', SubCategories: [] }
  ];
  SubCategoryList: Array<any> = [];
  OrgUsersList: any[];
  action: Subject<any> = new Subject();
  log_data: any;
  SubCategorygrayout: boolean = true;
  Programgrayout: boolean = true;
  Namegrayout: boolean = true;
  ApplicableProgrmaslst:any[];
  OrgDetail:any;

  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year = this.yesterday.getFullYear();
  moth = this.yesterday.getMonth() + 1;
  Day = this.yesterday.getDate();
  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public appService: ApidataRequestService,
    private commonService: CommonService,
    private userService:UserService,
    private emailtemplatesservice:EmailTemplatesService,
  ) { }

  ngOnInit(): void {
    this.IsAdvanceSearch = true;
    this.gridHeaderandActionSettings();
    this.AdminFormControls();
    this.GetOrgUsersList();
    this.SubCategoryList = [];
    this.getApplicablePrograms();
    this.OrgDetail=this.commonService.getOrganizationObject(localStorage.getItem("orgCode"));
    if(this.OrgDetail.IS_ANALYTICS_ATLEAST_ONCE== true)
    {
     // this.CategoryList=[{ name: 'Dashboards', SubCategories: [] }].concat(this.CategoryList);        
         this.CategoryList.push({name: 'Dashboards', SubCategories: [] });
       
    }
    this.AdminAuditForm.get("SubCategory").patchValue("");
    this.AdminAuditForm.get("Program").patchValue("");
    this.AdminAuditForm.get("Name").patchValue("");
    this.AdminAuditForm.controls["Name"].disable();
    this.AdminAuditForm.controls["SubCategory"].disable();
    this.AdminAuditForm.controls["Program"].disable();
    this.AdminAuditForm.get("Category").patchValue("");
    this.SubCategorygrayout = true;
    this.Programgrayout = true;
    this.Namegrayout = true;
  }

  ngOnDestroy(): void {
    if (this.subGetData)
      this.subGetData.unsubscribe();
    if (this.subSearchRecords)
      this.subSearchRecords.unsubscribe();
  }

  toggleCase() {
    this.IsAdvanceSearch = !this.IsAdvanceSearch;
  }

  AdminFormControls() {
    this.AdminAuditForm = new UntypedFormGroup({
      Category: new UntypedFormControl("" ,[Validators.required]),
      SubCategory: new UntypedFormControl(""),
      Program: new UntypedFormControl(""),
      Name: new UntypedFormControl(""),
      UserName: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      VersionID: new UntypedFormControl(""),
      RelatedPKID: new UntypedFormControl(""),
    })
  }

  getApplicablePrograms(){
    this.emailtemplatesservice.getApplicablePrograms(this.userService.getOrgCode()).subscribe(result=>{
      if(result != null && result != undefined){
        this.ApplicableProgrmaslst = result;
        this.ApplicableProgrmaslst=[{ label: "Select", value: "", checked: true }].concat(this.ApplicableProgrmaslst);
         this.ApplicableProgrmaslst.forEach(element=>{
          if(element.label=="EAP")
          {
            this.CategoryList=[{ name: 'EAP Type', SubCategories: [] }].concat(this.CategoryList);
          }
          });
      }
    });
  }

  GetOrgUsersList() {
    this.subGetData = this.appService.getData("api/AdminAuditTrail/GetAllOrgUsersList").subscribe(
      (res) => {
        if (res["Status"]) {
          this.OrgUsersList = res["Data"];
          this.OrgUsersList=[{ UserName: "Select", UserID: "", checked: true }].concat(this.OrgUsersList)
        } else {
          this.OrgUsersList = [];
        }
      },

      (err) => {
       // console.error(err);
      }
    );
  }

  gridHeaderandActionSettings() {
    this.columnDefs = [
      { headerName: "Revision", headerTooltip: "Revision", field: 'revision_num', sortable: false, tooltipField: "revision_num" },
      { headerName: "Name", headerTooltip: "Name", field: 'category', sortable: false, tooltipField: "category" },
      { headerName: "Change Description", headerTooltip: "Change Description", field: 'change_description', sortable: false, tooltipField: "change_description" },
      { headerName: "Username", headerTooltip: "Username", field: 'username', sortable: false, tooltipField: "username" },
      { headerName: "Program", headerTooltip: "Program", field: 'program', sortable: false, tooltipField: "program" },
      { headerName: "Changed on Date and Time", headerTooltip: "Changed on Date and Time", field: 'last_modified_date_string', sortable: false, tooltipField: "last_modified_date_string" }
    ];
    this.tempoperation = [];
    this.tempoperation.push({
      "name": "View",
      "id": "View"
    });
    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  OnCategoryChange(event) {
  
    this.SubCategoryList = [];
    this.AdminAuditForm.get("SubCategory").patchValue("");
    this.SubCategorygrayout = true;
    this.Programgrayout = true;
    this.Namegrayout = true;
    if (event.value != "") {
      this.SubCategoryList = this.CategoryList.find(con => con.name == event.value.name).SubCategories;
    }
    if (event.value == "" || (this.SubCategoryList.length == 0 && (event.value.name != "User Management" || event.value.name != "Product configuration" || event.value.name != "Alerts and Notifications"))) {
      this.AdminAuditForm.controls["SubCategory"].disable();
    }
    else {
      this.AdminAuditForm.controls["SubCategory"].enable();
      this.SubCategorygrayout = false;
    }

    this.AdminAuditForm.get("Name").patchValue("");
    if (event.value == "" || event.value.name == "Settings") {
      this.AdminAuditForm.controls["Name"].disable();
    }
    else {
      this.AdminAuditForm.controls["Name"].enable();
      this.Namegrayout = false;
    }

    this.AdminAuditForm.get("Program").patchValue("");
    this.AdminAuditForm.controls["Program"].disable();
    if (event.value.name == "Alerts and Notifications" || //event.target.value == "Workflow Setup" ||
      event.value.name == "Screen repository" || event.value.name == "Registrations" ||
      event.value.name == "List Values" || event.value.name == "Category and Subcategory" ||
      event.value.name == "Email Templates") {
      this.AdminAuditForm.controls["Program"].enable();
      this.Programgrayout = false;
    }

  }

  Clear() {
    this.AdminAuditForm.controls["StartDate"].setValue(null);
    this.AdminAuditForm.controls["EndDate"].setValue(null);
    this.AdminAuditForm.patchValue({
      Category: "",
      SubCategory: "",
      Program: "",
      Name: "",
      UserName: "",
      StartDate: null,
      EndDate: null,
      cComp: "",
      cDetails: "",
    });
    this.SubCategoryList = [];
    this.AdminAuditForm.controls["SubCategory"].disable();
    this.AdminAuditForm.controls["Program"].disable();
    this.AdminAuditForm.controls["Name"].disable();
    this.SubCategorygrayout = true;
    this.Programgrayout = true;
    this.Namegrayout = true;
    this.rowData = [];
    //this.SDates = "";
    //this.EDates = "";
  }


  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }
  Search() {
    debugger
    if (this.ValidateForm()) {
      this.auditTrailSearch = new AuditTrailSearch();
      this.auditTrailSearch.Category = this.AdminAuditForm.controls["Category"].value.name;
      this.auditTrailSearch.SubCategory = this.AdminAuditForm.controls["SubCategory"].value.Subname;
      this.auditTrailSearch.Program = this.AdminAuditForm.controls["Program"].value.value;
      this.auditTrailSearch.Name = this.AdminAuditForm.controls["Name"].value;
      this.auditTrailSearch.UserName = this.AdminAuditForm.controls["UserName"].value.UserID;
      this.auditTrailSearch.StartDate = this.AdminAuditForm.controls["StartDate"].value;
      this.auditTrailSearch.EndDate = this.AdminAuditForm.controls["EndDate"].value;
      this.auditTrailSearch.cDetails = "v";
      this.auditTrailSearch.cComp = "p";
      this.auditTrailSearch.StartDateO = this.Full_Start_Date;
      this.auditTrailSearch.EndDateO = this.Full_End_Date;
      this.clonedAuditSearch = JSON.parse(JSON.stringify(this.auditTrailSearch));
      this.subSearchRecords = this.appService.getDataPost("api/AdminAuditTrail/GetAuditTrailSearchSummary", this.auditTrailSearch).subscribe(result => {
        if (result.Status && result.Data.length > 0) {

          this.rowData = result.Data;
        } else {
          this.rowData = [];
        }
      });
    }
  }

  ValidateForm() {
    var err: any = [];
    //if (!this.AdminAuditForm.valid) {
      if (
        !this.AdminAuditForm.controls["Category"].value &&
        !this.AdminAuditForm.controls["SubCategory"].value &&
        !this.AdminAuditForm.controls["UserName"].value &&
        !this.AdminAuditForm.controls["StartDate"].value &&
        !this.AdminAuditForm.controls["EndDate"].value
      ) {
        err.push("Provide at least one criteria to perform search");
        this.commonService.ValidationBanner(err);
        return false;
      }
      if (this.AdminAuditForm.controls["StartDate"].value != null) {
        if (this.AdminAuditForm.controls["EndDate"].value == null) {
          err.push("Please select end date");
          this.commonService.ValidationBanner(err);
          return false;
        }
      }
      if (this.AdminAuditForm.controls["StartDate"].value == null) {
        if (this.AdminAuditForm.controls["EndDate"].value != null) {
          err.push("Please select start date");
          this.commonService.ValidationBanner(err);
          return false;
        }
      }
   
        if (this.AdminAuditForm.controls["Category"].value == "" ||
         this.AdminAuditForm.controls["Category"].value.name == "Select" || 
         this.AdminAuditForm.controls["Category"].value == undefined ) {
          err.push("Please select Category");
          this.commonService.ValidationBanner(err);
          return false;
        }
      
      if (
        this.AdminAuditForm.controls["Category"].value !== "" &&
        this.AdminAuditForm.controls["SubCategory"].value == ""
      ) {
        if (!this.AdminAuditForm.controls["SubCategory"].disabled) {
          err.push("Please select the sub-category");
          this.commonService.ValidationBanner(err);
          return false;
        }
      }

      if (
        this.AdminAuditForm.controls["Category"].value !== "" &&
        this.AdminAuditForm.controls["Program"].value == ""
      ) {
        if (!this.AdminAuditForm.controls["Program"].disabled) {
          err.push("Please select the Program");
          this.commonService.ValidationBanner(err);
          return false;
        }
      }

      if (
        !this.AdminAuditForm.controls["UserName"].value &&
        ((this.AdminAuditForm.controls["StartDate"].value == null &&
        this.AdminAuditForm.controls["EndDate"].value == null) ||
        (this.AdminAuditForm.controls["StartDate"].value == "" &&
        this.AdminAuditForm.controls["EndDate"].value == ""))
      ) {
        err.push("Please select username /date range");
        this.commonService.ValidationBanner(err);
        return false;
      }

      if (
        !this.AdminAuditForm.controls["UserName"].value &&
        this.AdminAuditForm.controls["StartDate"].value == null
      ) {
        err.push("Please select end date");
        this.commonService.ValidationBanner(err);
        return false;
      }


    return true;
  }



  View() {
    var VersionID = this['self'].selectedRow['versionID'];
    this["self"].clonedAuditSearch.cDetails = "D";
    this["self"].clonedAuditSearch.cComp = "C";
    this["self"].clonedAuditSearch.versionID = VersionID;
    this.log_data = this['self'].selectedRow;
    var heading = this['self'].clonedAuditSearch.Category;
    let modalRef1 = this['self'].modalService.open(AdmincategorySubcategoryAuditlogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });

    modalRef1.componentInstance.Content ={
      heading: heading,
      content: {
        ID: VersionID, OperationType: "View",
        SearchData: this["self"].clonedAuditSearch, log_data: this.log_data,
      }
    };
  }

  onRowDoubleClicked(event) {
    var VersionID = event.data['versionID'];
    this.clonedAuditSearch.cDetails = "D";
    this.clonedAuditSearch.cComp = "C";
    this.clonedAuditSearch.versionID = VersionID;
    var heading = this.clonedAuditSearch.Category;
    this.log_data = event.data;
    let modalRef1 = this.modalService.open(AdmincategorySubcategoryAuditlogComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-xl right modal-right',
      animation: true
    });
    modalRef1.componentInstance.Content = {
      heading: heading,
      content: {
        ID: VersionID, OperationType: "View",
        SearchData: this.clonedAuditSearch, log_data: this.log_data,
      }
    }
    modalRef1.result.then((result) => {
    });
    }

}

export class AuditTrailSearch {
  versionID?: string;
  Category?: string = "";
  SubCategory?: string = "";
  Program?: string = "";
  Name?: string = "";
  UserName?: string = "";
  StartDate?: string = "";
  EndDate?: string = "";
  cDetails?: string;
  cComp?: string;
  Related_pk_id?: string;
  OrgID?: string;
  StartDateO : DateObject;
  EndDateO:DateObject;
}
